export default [
  {
    imageUrl: 'https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_side-income.png',
    subTitle: 'Be a Driver with airasia ride or a Rider with airasia food and airasia xpress and earn extra money during your free time.',
    title: 'Earn A Side Income'
  },
  {
    imageUrl: 'https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_flexible-hours.png',
    subTitle: 'With airasia ride, airasia food and airasia xpress, you can work wherever you want, whenever you want!',
    title: 'Flexible Work Hours'
  },
  {
    imageUrl: 'https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_incentive.png',
    subTitle: 'As an airasia Rider / Driver, you’ll receive fantastic perks like airasia food and grocery vouchers, Car wash discounts, Tyre discounts, Battery, Vehicle Maintenance, and <a href="https://www.airasia.com/aa/ride/benefits/">more benefits</a>.',
    title: 'Incentives & Perks'
  }
]
